// Cửa sạp Phường Thị: một hàng mỗi món, giá cố định, nút MUA / BÁN (bậc ① đổi tại chỗ). Quầy thu tách
// linh dược theo niên phân (giá theo niên phân).
import type { JSX } from 'preact';
import { t } from '@i18n/t';
import { formatFull } from '@i18n/format';
import { MARKET } from '@data/content/market';
import { isWalletCurrency } from '@data/currencies';
import { buy, owned, sell, sellableKeys, sellPriceOf } from '@state/modules/market';
import { inventory } from '@state/modules/inventory';
import { wallet } from '@state/modules/wallet';
import { TextButton } from '../../kit/TextButton';
import { goodsName } from '../../itemView';

export function MarketWindow({ mode }: { mode: 'buy' | 'sell' }): JSX.Element {
  // Đọc để vẽ lại khi ví / túi đổi.
  void inventory.value;
  const w = wallet.value;
  const rows =
    mode === 'buy'
      ? MARKET.filter((e) => e.buy !== null).map((e) => ({ key: e.id, price: e.buy! }))
      : sellableKeys().map((k) => ({ key: k, price: sellPriceOf(k) }));
  return (
    <>
      <div class="ht-rows" data-id={`market-${mode}-rows`}>
        {rows.length === 0 && <p class="ht-reason dim">{t('ui.market.nothing')}</p>}
        {rows.map(({ key, price }) => (
          <div class="ht-statline" key={key}>
            <span>
              <b class="row-name">{isWalletCurrency(key) ? t(`currency.${key}`) : goodsName(key)}</b>
              <small>{t('ui.market.have', { n: formatFull(owned(key)) })}</small>
            </span>
            <span class="ht-chip price" style={{ '--cur-rgb': 'var(--cur-spiritStone-rgb)' }}>
              {formatFull(price)}
            </span>
            <TextButton
              id={`market-${mode}-${key}`}
              disabled={mode === 'buy' ? w.spiritStone < price : owned(key) < 1}
              onClick={() => (mode === 'buy' ? buy(key) : sell(key))}
            >
              {t(mode === 'buy' ? 'ui.market.buy' : 'ui.market.sell')}
            </TextButton>
          </div>
        ))}
      </div>
    </>
  );
}
